import { useMutation, useQueryClient } from '@tanstack/react-query';

import { RestApiError } from 'services/api/restful/errors';
import {
  getGetFavouriteQueryKey,
  getListFavouritesQueryKey,
  removeFavourite,
} from 'services/api/restful/generated/accounts/accounts';
import type { FavouriteType } from 'services/api/restful/generated/nofomoRestApi.schemas';

type RemoveFavouriteVariables = { type: FavouriteType; value: string };

export const useRemoveFavourite = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<void, RestApiError, RemoveFavouriteVariables>({
    mutationFn: async ({ type, value }) => {
      await removeFavourite(type, value);
    },
    onSuccess: async (_data, { type, value }) => {
      await queryClient.invalidateQueries({
        queryKey: getListFavouritesQueryKey(),
      });
      await queryClient.invalidateQueries({
        queryKey: getGetFavouriteQueryKey(type, value),
      });
    },
  });

  return {
    removeFavourite: (
      type: FavouriteType,
      value: string,
      options?: { onError?: () => void },
    ) => mutation.mutate({ type, value }, options),
    isLoading: mutation.isPending && !mutation.isPaused,
    error: mutation.error,
  };
};
